module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_500.115fab1d.png";